import { request_detail, request_list, remove_detail, request_header } from '@/commons/hpod';
import { sendSuccessNotice, sendErrorNotice } from '@/commons/utils';
import Vue from 'vue';
import configs from '@/configs';
const endpoint = 'flags'
const viewTitle = 'hashtag'

// initial state
const state = {
    loading: false,
    all: {},
    selected: {
        ID: 0,
        FlagName: '',
        ShortTag: '',
        FlagColor: '',
        Note: ''
    }
};

// getters
const getters = {};

// actions
const actions = {
    getList({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list(endpoint, data => {
            commit('setList', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getDetail({ commit }, id) {
        commit("setLoading", { loading: true });
        request_detail(endpoint, data => {
            commit('setDetail', data);
            commit("setLoading", { loading: false });
        }, Vue.http, id, this.state.authentication.token);
    },
    setDetail({ commit }, {data, id}) {
        const header = {
            headers: request_header(this.state.authentication.token)
        };
        if(id > 0) {
            return Vue.http.post(`${configs.API}/admin/api/${endpoint}/${id}`, data, header).then(res => {
                if (res.data.data && res.data.data.status === 'fail') {
                    sendErrorNotice(`Không thể cập nhật ${viewTitle}.`)
                    return false;
                }
                sendSuccessNotice(`Cập nhật ${viewTitle} thành công.`)
                return true;
            }, err => {
                sendErrorNotice((err.body && err.body.reason) || `Không thể cập nhật ${viewTitle}.`);
                return false;
            });
        }
        else {
            delete data.ID;
            return Vue.http.put(`${configs.API}/admin/api/${endpoint}/`, data, header).then(res => {
                if (res.data.data && res.data.data.status === 'fail') {
                    sendErrorNotice(`Không thể thêm mới ${viewTitle}.`)
                    return false;
                }
                sendSuccessNotice(`Thêm mới ${viewTitle} thành công.`);
                return true;
            }, err => {
                sendErrorNotice((err.body && err.body.reason) || `Không thể thêm mới ${viewTitle}.`);
                return false;
            });
        }
    },
    removeDetail({ commit }, id) {
        commit("setLoading", { loading: true });
        remove_detail(endpoint, res => {
            if (res.data.status === false) {
                sendErrorNotice(`Không thể xóa ${viewTitle}.`)
            }
            else {
                sendSuccessNotice(`Đã xóa ${viewTitle} thành công.`)
            }
            commit("setLoading", { loading: false });
        }, Vue.http, id, this.state.authentication.token);
    },
};

// mutations
const mutations = {
    setList(state, data) {
        state.all = data;
    },
    setDetail(state, item) {
        state.selected = item.data;
    },
    setLoading(state, { loading }) {
        state.loading = loading;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
